import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { Point } from '@ipfabric/utils';
import type React from 'react';

export const getMouseEventElementCoordinates = (
  event: MouseEvent | React.MouseEvent,
  element?: HTMLElement,
): Point => {
  const appliedElement = element ?? event.currentTarget;
  if (appliedElement === null || !('getBoundingClientRect' in appliedElement)) {
    stumble(
      'getMouseEventElementCoordinates: element is null or has no bounding rect',
    );
    return { x: 0, y: 0 };
  }
  const rect = (appliedElement as HTMLElement).getBoundingClientRect();
  return {
    x: event.clientX - rect.left,
    y: event.clientY - rect.top,
  };
};
